import { REQUEST, SUCCESS, FAILURE } from 'Redux/actions/constants'
import {
  USER_SEARCHES,
  API_SAVE_USER_SEARCH,
  SAVE_SEARCH_CLEAR_MSG,
  API_DELETE_USER_SEARCH,
  API_UPDATE_USER_SEARCH,
  TURN_OFF_ALL_LISTING_ALERTS,
  FETCH_ALERT_LISTINGS_API,
  UPDATE_ALERT_TAGS_API,
} from './actions'

import {
  RESET_ALERTS,
} from '../actions'


const initialState = {
  isFetching: true,
  isUpdating: false,
  deletingId: null,
  isReComputingTags: false,
  isSaving: false,
  list: null,
  successMessage: null,
  errorsObj: null,
  // listingList : { alertId: { isFetching, listings: [] }}
  alertListings: {},
  listingsList: null,
  isFetchingListings: false,
  listingsPagination: {
    total: 0,
    perPage: 0,
    currentPage: 1,
  },

  buildingsList: null,
  isFetchingBuildings: false,
  buildingsPagination: {
    total: 0,
    perPage: 0,
    currentPage: 1,
  },

  buildinglistingsList: null,
  isFetchingBuildingListings: false,

  leadProfileResponseData: null,
  isFetchingLeadProfile: false,
}


function userSearchesReducer(state = initialState, action) {
  const actionType = action.type
  const actionResponse = action.response && action.response.data

  const reducerState = Object.assign({}, state)

  // eslint-disable-next-line
  switch(actionType) {
    case USER_SEARCHES[REQUEST]:
      reducerState.isFetching = true
      break
    case USER_SEARCHES[SUCCESS]:
      reducerState.isFetching = false
      reducerState.list = actionResponse.data
      break
    case USER_SEARCHES[FAILURE]:
      reducerState.isFetching = false
      break

    case API_SAVE_USER_SEARCH[REQUEST]:
      reducerState.isSaving = true
      reducerState.errorsObj = null
      reducerState.successMessage = null
      break
    case API_SAVE_USER_SEARCH[SUCCESS]:
      reducerState.isSaving = false
      if(actionResponse.status === -1) {
        reducerState.errorsObj = actionResponse.data && actionResponse.data.errors
      } else if(actionResponse.status === 1) {
        reducerState.successMessage = actionResponse.data.message
      }
      break
    case SAVE_SEARCH_CLEAR_MSG:
    case API_SAVE_USER_SEARCH[FAILURE]:
      reducerState.isSaving = false
      if(action && action.error && action.error.body && action.error.body.status === -1) {
        const errorsObj = {
          'message': action.error.body.message,
        }
        reducerState.errorsObj = errorsObj
      }
      reducerState.successMessage = null
      break


    case API_DELETE_USER_SEARCH[REQUEST]:
      return {
        ...state,
        isDeleting: true,
        deletingId: action.id,
      }
    case API_DELETE_USER_SEARCH[SUCCESS]:
      const { request } = action
      const alerts = state.list.listing_alerts
      const buildingAlertCount = state.list.listing_alert_total
      const total = buildingAlertCount > 1 ? buildingAlertCount - 1 : 0

      return {
        ...state,
        list: {
          ...state.list,
          listing_alerts: alerts.filter(alert => alert.id !== request.id),
          listing_alert_total: total,
        },
        isDeleting: false,
        deletingId: null,
      }
    case API_UPDATE_USER_SEARCH[REQUEST]:
      return {
        ...state,
        isUpdating: true,
      }
    case API_UPDATE_USER_SEARCH[SUCCESS]:
      const updateRes = action.response.data
      const id = action.request.id
      let updatedAlerts = state.list && state.list.listing_alerts
      if(updatedAlerts && updateRes.status === 1) {
        const message = updateRes.data.message
        updatedAlerts = updatedAlerts.map(alert => {
          if(alert.id === id) {
            return {
              ...alert,
              ...updateRes.data.saved_search,
              successMessage: message,
            }
          }
          return alert
        })
        return {
          ...state,
          isUpdating: false,
          list: {
            ...state.list,
            listing_alerts: updatedAlerts,
          },
        }
      }
      return {
        ...state,
        isUpdating: false,
      }
    case TURN_OFF_ALL_LISTING_ALERTS:
      if(state.list) {
        const listingAlerts = state.list.listing_alerts
        const noAlertList = listingAlerts.map(alert => ({
          ...alert,
          alert_frequency: 0,
        }))
        return {
          ...state,
          list: {
            ...state.list,
            listing_alerts: noAlertList,
          },
        }
      }
      return state
    case RESET_ALERTS:
      return {
        ...initialState,
      }
    case FETCH_ALERT_LISTINGS_API[REQUEST]:
      return {
        ...state,
        alertListings: {
          ...state.alertListings,
          [action.alertId]: {
            isFetching: true,
          },
        },
      }
    case FETCH_ALERT_LISTINGS_API[SUCCESS]:
      const { res, alertId } = action.response
      const { hits } = res
      const listing = hits[0] || null
      if(!listing) return state
      return {
        ...state,
        alertListings: {
          ...state.alertListings,
          [alertId]: {
            listing,
            listings: hits,
            nbHits: res.nbHits,
            isFetching: false,
          },
        },
      }

    case UPDATE_ALERT_TAGS_API[REQUEST]:
      return {
        ...state,
        isReComputingTags: true,
      }
    case UPDATE_ALERT_TAGS_API[SUCCESS]:
      return {
        ...state,
        isReComputingTags: false,
      }
    case UPDATE_ALERT_TAGS_API[FAILURE]:
      return {
        ...state,
        isReComputingTags: false,
      }
  }

  return reducerState
}

export default userSearchesReducer
